import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { PropertyLevelProgressDto } from '../../../shared/types/PropertyLevelProgressDto';
import { StudyBundleCourseDto } from '../../../shared/types/StudyBundleCourseDto';
import MiniLessonsCalculations from '../mini-lessons-calculations';

@Component({
  selector: 'lp2-mini-lesson-section-header',
  templateUrl: './mini-lesson-section-header.component.html',
  styleUrls: ['./mini-lesson-section-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MiniLessonSectionHeaderComponent implements OnChanges {
  @Input() lessonPoints: number;
  @Input() lessons: StudyBundleCourseDto[];
  @Input() unitLevelProgress: PropertyLevelProgressDto;

  lessonsWithoutAssessment: StudyBundleCourseDto[];
  takenUnitsCounter: number;
  completedLessonsPercentage: number;
  completedLessonsWithoutAssessment: number;

  ngOnChanges() {
    this.lessonsWithoutAssessment = MiniLessonsCalculations.lessonsWithoutAssessment(this.lessons);
    this.completedLessonsWithoutAssessment = MiniLessonsCalculations.completedLessons(this.lessonsWithoutAssessment);
    this.completedLessonsPercentage = MiniLessonsCalculations.completedLessonsPercentage(this.lessonsWithoutAssessment);
    this.takenUnitsCounter = this.calculateUnitsTaken(this.unitLevelProgress.taken, this.unitLevelProgress.required);
  }
  private calculateUnitsTaken(taken: number, required: number) {
    return taken < required ? taken + 1 : taken;
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/mini-lesson-section/mini-lesson-section-header/mini-lesson-section-header.component.ts